import { get } from "lodash";
import { ColumnFilter } from "../types";
import { SELECT_ALL_VALUE } from "../constants";

export function searchFilterByColumn(filter: ColumnFilter, row: any) {
  const selectedValues = filter.value || [];

  if (!selectedValues.length) return true;

  if (selectedValues.includes(SELECT_ALL_VALUE)) return true;

  return selectedValues.includes(get(row, filter.id));
}

export function searchFilterFoTable(data: any[], filters: ColumnFilter[]) {
  return filters.reduce(
    (filteredData: any[], filter: ColumnFilter) => filteredData.filter(row => searchFilterByColumn(filter, row)),
    data
  );
}
